import { ContactLabels } from '@cian/contact-card-component';
import { Star16 } from '@cian/ui-kit';
import * as React from 'react';

interface IAgentReviews {
  title: string;
}

const AgentReviewsComponent: React.FC<IAgentReviews> = ({ title }) => {
  return (
    <ContactLabels
      labels={[
        {
          icon: <Star16 color="warning_100" />,
          title,
        },
      ]}
    />
  );
};

export const AgentReviews = React.memo(AgentReviewsComponent);
